import api from './apiClient';

const apiSendFeedback = async payload => {
    const response = await api.post('/api/captions/sendFeedbackEmail', payload);
    return response.data;
};

export default apiSendFeedback;
